import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PortfolioPage from "./pages/PortfolioPage";
import DartLeaguePage from "./pages/DartLeaguePage";
import "./App.css";
import "./global.css";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PortfolioPage />} />
        <Route path="/501DartLeague" element={<DartLeaguePage />} />
      </Routes>
    </Router>
  );
};

export default App;
